import { render, staticRenderFns } from "./nested-Customer.vue?vue&type=template&id=0fb4c8a0&"
import script from "./nested-Customer.vue?vue&type=script&lang=js&"
export * from "./nested-Customer.vue?vue&type=script&lang=js&"
import style0 from "./nested-Customer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports